import { updateSelectedApPayeeIsBank } from '@/components/ApPayee/useChangeIsBankTransfer';
import { useUpdateInvoiceRegistrationNumberAndSetBusinessPersonData } from '@/context/BusinessPersonData';
import { TPMData } from '@/context/services/tpm/type';
import { ApPayeeDetail } from 'ap-openapi';
import { stringToDayjs } from 'date-util';
import { useCallback } from 'react';
import {
  FieldPath,
  FieldValues,
  Path,
  PathValue,
  useFormContext,
} from 'react-hook-form';

export const useUpdatePayeeRelatedInfo = <TFieldValues extends FieldValues>(
  bookDateName: FieldPath<TFieldValues>,
  dueDateName: FieldPath<TFieldValues>,
  onCallbackUpdatePayeeRelatedInfo: (
    tpmValue: TPMData | undefined
  ) => Promise<void>,
  invoiceRegistrationNumberName?: FieldPath<TFieldValues>
) => {
  const updateInvoiceRegistrationNumberAndSetBusinessPersonData =
    useUpdateInvoiceRegistrationNumberAndSetBusinessPersonData();
  const { setValue, clearErrors } = useFormContext<TFieldValues>();
  return useCallback(
    async (payee: ApPayeeDetail | undefined) => {
      const bookDate = stringToDayjs(payee?.book_date);
      if (bookDate) {
        setValue(
          bookDateName,
          // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
          bookDate as PathValue<TFieldValues, Path<TFieldValues>>
        );
        clearErrors(bookDateName);
      }
      const paymentDate = stringToDayjs(payee?.payment_date);
      if (paymentDate) {
        setValue(
          dueDateName,
          // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
          paymentDate as PathValue<TFieldValues, Path<TFieldValues>>
        );
        clearErrors(dueDateName);
      }
      const invoiceRegistrationNumber =
        payee?.invoice_registration_number ?? null;
      if (invoiceRegistrationNumberName) {
        const tpmData =
          await updateInvoiceRegistrationNumberAndSetBusinessPersonData(
            invoiceRegistrationNumberName,
            invoiceRegistrationNumber
          );
        await onCallbackUpdatePayeeRelatedInfo(tpmData?.parseValidityDate());
      }

      if (payee?.payment_method === 'bank_transfer') {
        updateSelectedApPayeeIsBank(true);
      } else {
        updateSelectedApPayeeIsBank(false);
      }
    },
    [
      bookDateName,
      clearErrors,
      dueDateName,
      invoiceRegistrationNumberName,
      onCallbackUpdatePayeeRelatedInfo,
      setValue,
      updateInvoiceRegistrationNumberAndSetBusinessPersonData,
    ]
  );
};
